<template>
  <div>
    <Head :title="`${title} #${order.number_order ?? order.id} | ${order.order_state == 'cancel' ? 'PEDIDO ANULADO' : ''}`" />

    <div class="flex justify-between">
      <div class="flex mb-2">
        <button class="p-2 mr-2 text-white bg-sky-700 rounded" @click="back()">
          <i class="fa fa-arrow-left"></i>
        </button>
        <h1 class="text-3xl font-bold">{{title}} #{{ order.number_order ?? order.id }} <span class="text-red-500" v-if="order.order_state == 'cancel'">PEDIDO ANULADO</span></h1>
      </div>

      <div>
        <a v-if="order.order_state != 'estimate'" target="_blank" :href="`/orders/${order.id}/report-invoice`" class="btn-blue mr-2 p-2 rounded"> <i class="fa fa-print text-white" /> Factura de camino </a>
        <a v-if="order.order_state == 'estimate'" target="_blank" :href="`/orders/${order.id}/report`" class="btn-blue mr-2 p-2 rounded"> <i class="fa fa-print text-white" /> Presupuesto </a>
        <a v-if="order.order_state != 'estimate' && role != 'storer'" target="_blank" :href="`/orders/${order.id}/report-storer`" class="btn-blue mr-2 p-2 rounded"> <i class="fa fa-print text-white" /> Nota de entrega </a>
        <a v-if="order.order_state == 'picking' || order.order_state == 'packing'" target="_blank" :href="`/orders/${order.id}/report-dispatch`" class="btn-blue mr-2 p-2 rounded"> <i class="fa fa-print text-white" /> Guia de despacho </a>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div class="bg-white rounded-xl shadow p-2">
        <h2 class="text-xl font-semibold mb-2">{{ order.client.companyName ?? order.client.name }}</h2>
        <p>{{ order.client.identification }}</p>
        <p>{{ order.client.email }}</p>
        <p>{{ order.client.phone }}</p>
        <p>Descuento: {{ order.client.discount }}%</p>
      </div>
      <div class="bg-white rounded-xl shadow p-2">
        <p><strong>Estado: </strong>
          <span class="text-md font-semibold mb-2" v-if="order.order_state == 'estimate'">PRESUPUESTO</span>
          <span class="text-md font-semibold mb-2" v-if="order.order_state == 'cancel'">ANULADA</span>
          <span class="text-md font-semibold mb-2" v-if="order.order_state == 'request'">PENDIENTE POR PAGO</span>
          <span class="text-md font-semibold mb-2" v-if="order.order_state == 'finish'">FINALIZADA</span>
          <span class="text-md font-semibold mb-2" v-if="order.order_state == 'pay'">PAGADA</span>
          <span class="text-md font-semibold mb-2" v-if="order.order_state == 'delivery'">EN TRANSPORTE</span>
          <span class="text-md font-semibold mb-2" v-if="order.order_state == 'picking'">Picking</span>
          <span class="text-md font-semibold mb-2" v-if="order.order_state == 'packing'">Packing</span>
          <span class="text-md font-semibold mb-2" v-if="order.order_state == 'dispatch'">En lote de carga</span>
        </p>
        <p><strong>Modalidad: </strong> {{ order.isCredit ? 'Credito' : 'Contado' }}</p>
        <p><strong>Fecha de vencimiento:</strong> {{ order?.expiry_date }}</p>
        <p><strong>Vendedor:</strong> {{ order?.responsible?.first_name }} {{ order?.responsible?.last_name }}</p>
      </div>
      <div class="bg-white rounded-xl shadow p-2">
        <h2 class="text-xl font-semibold mb-2">Observaciones</h2>
        <p>{{order.comentary}}</p>
        <span v-html="barcode"></span>
        <div v-if="order.only_cash" class="pb-2">
          <strong>Solo para pagar en efectivo</strong>
        </div>
      </div>
    </div>

    <div v-if="role == 'admin' || role == 'financial' || role == 'sales' || role == 'supersales'" class="grid grid-cols-1 md:grid-cols-4 gap-4 mt-2">
      <div class="bg-white rounded-xl shadow p-2">
        <h2 class="text-xl font-semibold mb-2">Total</h2>
        <h2 class="text-md font-bold mb-2 text-center">${{order.total.toFixed(2)}} (BsD. {{ (order.total * order.change).toFixed(2) }})</h2>
      </div>
      <div class="bg-white rounded-xl shadow p-2">
        <h2 class="text-xl font-bold mb-2">Descuento</h2>
        <h2 class="text-md font-bold mb-2 text-center">${{order.discount.toFixed(2)}} (BsD. {{ (order.discount * order.change).toFixed(2) }})</h2>
      </div>
      <div class="bg-white rounded-xl shadow p-2">
        <h2 class="text-xl font-bold mb-2">Balance</h2>
        <h2 class="text-md font-bold mb-2 text-center">${{order.balance.toFixed(2)}} (BsD. {{ (order.balance * order.change).toFixed(2) }})</h2>
      </div>
      <div class="bg-white rounded-xl shadow p-2">
        <h2 class="text-xl font-bold mb-2">Deuda</h2>
        <h2 class="text-md font-bold mb-2 text-center">${{(order.total - order.balance).toFixed(2)}} (BsD. {{ (((order.total - order.balance).toFixed(2)) * order.change).toFixed(2) }})</h2>
      </div>
    </div>

    <div class="flex justify-between mb-5 p-5 bg-white rounded-xl shadow overflow-x-auto mt-2">
      <div>
        <div class="pb-2">
          <!-- <button v-if="order.order_state == 'estimate'" @click="changeOrderState('no-credit')" class="btn-blue">Procesar orden de contado</button>
          <button v-if="order.order_state == 'estimate'" @click="changeOrderState('no-credit', 'cash')" class="btn-blue">Procesar orden de contado y en efectivo</button>
          <button v-if="order.order_state == 'estimate' && order.client.credit" @click="changeOrderState('credit')" class="btn-blue">Procesar orden a credito a {{order.client.term_credit}} dias</button> -->
          <!-- <button v-if="order.order_state == 'delivery' && (role == 'admin' || role == 'supersales')" @click="changeOrderState()" class="btn-blue">Procesar orden a finalizada</button> -->
          <a v-if="order.order_state == 'estimate'" :href="`/orders/${order.id}/edit`" class=" btn-blue">Editar</a>
          <button v-if="order.order_state == 'picking' && (role == 'admin' || role == 'supersales')" @click="changeOrderState()" class="btn-blue">Procesar orden</button>
          <!-- <button v-if="order.order_state != 'cancel' || order.order_state == 'estimate'" @click="cancelOrder()" class="text-md p-3 text-white bg-red-500 rounded-full font-semibold">Anular</button> -->
        </div>
      </div>

    </div>

    <order-state 
      v-if="order.order_state == 'estimate' && (role == 'admin' || role == 'supersales')"
      :order="order"
    ></order-state>

    <order-expiry-date
      v-if="order.order_state == 'request'"
      :order="order"
    />

    <div v-if="(role == 'financial' || role == 'admin' || role == 'sales' || role == 'supersales') && order.order_state != 'cancel' && order.order_state != 'estimate'" class="mb-5 mt-5 p-5 bg-white rounded-xl shadow">
      <div>
        <div class="flex justify-between">
          <h2 class="mb-8 text-xl font-bold">Pagos</h2>
        </div>
      </div>
      <payment-box v-if="order.order_state != 'finish'" :quick="true" :payment_methods="payment_methods" :balance="order.total - order.balance" :change="order.change" :order="order" />
      <div class="overflow-x-auto">
        <table class="w-full whitespace-nowrap">
          <thead>
            <tr>
              <th class="pb-4 pt-6 px-6">Metodo</th>
              <th class="pb-4 pt-6 px-6">Monto</th>
              <th class="pb-4 pt-6 px-6">Monto Bs</th>
              <th class="pb-4 pt-6 px-6">Tasa</th>
              <th class="pb-4 pt-6 px-6">Fecha</th>
              <th class="pb-4 pt-6 px-6">Referencia</th>
              <th class="pb-4 pt-6 px-6">Comprobante</th>
              <th class="pb-4 pt-6 px-6">Soporte de pago</th>
              <th v-if="(role == 'financial' || role == 'admin')" class="pb-4 pt-6 px-6">Acción</th>
              <th v-if="role != 'financial' || role != 'admin'" class="pb-4 pt-6 px-6">Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="pay in order.pays" :key="pay.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
              <td class="p-2 text-center border-t capitalize">
                {{ pay.method }}
              </td>
              <td class="p-2 text-center border-t">
                {{ pay.amount }}
              </td>
              <td class="p-2 text-center border-t">
                {{ pay.amount_bs }}
              </td>
              <td class="p-2 text-center border-t">
                {{ pay.change ?? 'N/A'}}
              </td>
              <td class="p-2 text-center border-t">
                {{ pay.date ? formatDate(pay.date) : formatDate(pay.created_at) }}
              </td>
              <td class="p-2 text-center border-t">
                {{ pay.reference }}
              </td>
              <td class="p-2 text-center border-t">
                <a target="_blank" :href="`/orders/pay/${pay.id}/report`" class="bg-blue"><i class="fa fa-print"></i> Recibo</a>
              </td>
              <td class="p-2 text-center border-t">
                <a v-if="pay.voucher" target="_blank" :href="`/storage/${pay.voucher}`" class="bg-blue"><i class="fa fa-file"></i> Soporte</a>
              </td>
              <td v-if="(role == 'financial' || role == 'admin')" class="p-2 text-center border-t">
                <button v-if="pay.state == 'pending'" @click="changeStatePay(pay.id,'approve')" class="bg-green-500 rounded p-2 text-white mr-2">
                  Aprobar
                </button>
                <button v-if="pay.state == 'pending'" @click="changeStatePay(pay.id,'reject')" class="bg-red-500 rounded p-2 text-white">
                  Rechazar
                </button>
              </td>
              <td class="p-2 text-center border-t">
                <span v-if="pay.state == 'pending'" class="bg-gray-200 rounded-md p-1">Pendiente por aprobar</span>
                <span v-if="pay.state == 'approve'" class="bg-green-200 rounded-md p-1">Aprobado</span>
                <span v-if="pay.state == 'reject'" class="bg-red-200 rounded-md p-1">Rechazado</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mt-6 flex justify-end">
        <a :href="`/orders/${order.id}/pays`" target="_blank" class="btn-blue">
            <i class="fa fa-print"></i> Imprimir recibos generales
          </a>
      </div>
    </div>

    <div class="p-5 bg-white rounded-xl shadow overflow-x-auto">
      
      <table v-if="role != 'storer'" class="w-full whitespace-nowrap">
        <thead>
          <tr>
            <th class="pb-4 pt-6 px-6"></th>
            <th class="pb-4 pt-6 px-6">Codigo</th>
            <th class="pb-4 pt-6 px-6">Descripcion</th>
            <th class="pb-4 pt-6 px-6">Deposito</th>
            <th>Cantidad</th>
            <th v-if="role != 'storer'" class="pb-4 pt-6 px-6">Precio</th>
            <th v-if="role != 'storer'" class="pb-4 pt-6 px-6">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(product, key) in order.products" :key="product.id" :class="`${product.dispatch ? 'bg-blue-300' : ''}`">
            <td class="p-2 text-center border-t">
              <input v-model="products.products[key]['dispatch']" :value="product.id" type="checkbox" />
            </td>
            <td class="p-2 text-center border-t">
              {{ product?.product?.code }}
            </td>
            <td class="p-2 text-center border-t">
              {{ product?.product?.description }}
            </td>
            <td class="p-2 text-center border-t">
              {{ product.deposit.name }}
            </td>
            <td class="p-2 text-center border-t">
              {{ product.quantity }}
            </td>
            <td v-if="role != 'storer'" class="p-2 text-center border-t">${{ product.price.toFixed(2) }}</td>
            <td v-if="role != 'storer'" class="p-2 text-center border-t">${{ (product.price * product.quantity).toFixed(2) }}</td>
          </tr>
        </tbody>
        <tfoot v-if="role != 'storer'"  class="px-6 py-2" style="background-color: #f3f3f3">
          <tr>
            <td class="p-2 text-center border-t"></td>
            <td class="p-2 text-center border-t"></td>
            <td class="p-2 text-center border-t"></td>
            <td class="p-2 text-center border-t"></td>
            <td class="p-2 text-center border-t"></td>
            <td class="p-2 text-center border-t"><strong>Subtotal</strong></td>
            <td class="p-2 text-center border-t">${{ (order.total + order.discount).toFixed(2) }}</td>
          </tr>
          <tr v-for="discount in order.discounts" :key="discount.id">
            <td class="p-2 text-center border-t"></td>
            <td class="p-2 text-center border-t"></td>
            <td class="p-2 text-center border-t"></td>
            <td class="p-2 text-center border-t"></td>
            <td class="p-2 text-center border-t">{{discount.description}}</td>
            <td class="p-2 text-center border-t"><strong>Descuento ({{discount.percentage}}%)</strong></td>
            <td class="p-2 text-center border-t">${{ (discount.amount).toFixed(2) }} 
              <button @click="deleteDiscount(discount.id)" class="bg-red-500 rounded text-white p-1">
                <i class="fa fa-times"></i>
              </button>
            </td>
          </tr>
          <tr>
            <td class="p-2 text-center border-t"></td>
            <td class="p-2 text-center border-t"></td>
            <td class="p-2 text-center border-t"></td>
            <td class="p-2 text-center border-t"></td>
            <td class="p-2 text-center border-t"></td>
            <td class="p-2 text-center border-t"><strong>Total</strong></td>
            <td class="p-2 text-center border-t">${{( order.total).toFixed(2) }}</td>
          </tr>
        </tfoot>
      </table>
      <!-- <button v-if="order.order_state == 'delivery'" @click="addDispatch" class="text-md my-2 p-2 text-white bg-sky-700 rounded">Despachar productos</button> -->
    </div>


    <order-discount 
      v-if="order.order_state == 'estimate' || order.order_state == 'request'"
      :order="order"
    ></order-discount>


    <div v-if="order.order_state == 'picking' && role == 'storer'" class="mt-5 p-5 bg-white rounded-xl shadow overflow-x-auto">
      <h2 class="mb-8 text-xl font-bold">Picking</h2>
      
      <div class="flex items-center gap-4 mb-6">
        <div class="flex-1">
          <text-input
            v-model="packing.code"
            type="text"
            :error="form.errors.code"
            class="w-full"
            label="Código de producto"
            placeholder="Ingrese el código"
            @keyup.enter="addPacking"
          />
        </div>
        <div class="flex-1">
          <text-input
            v-model="packing.quantity"
            type="number"
            min="1"
            step="1"
            :error="form.errors.long"
            class="w-full"
            label="Cantidad"
            placeholder="Ingrese la cantidad"
            @keyup.enter="addPacking"
          />
        </div>
        <button 
          class="btn-blue h-10 px-6 mt-6"
          :disabled="!packing.code || !packing.quantity"
          @click="addPacking()"
        >
          <i class="fa fa-plus mr-2"></i>
          Agregar
        </button>
      </div>

      <div class="overflow-x-auto rounded-lg border">
        <table class="w-full">
          <thead class="bg-gray-50">
            <tr>
              <th class="p-3 text-left">Código</th>
              <th class="p-3 text-left">Descripción</th>
              <th class="p-3 text-center">Cantidad requerida</th>
              <th class="p-3 text-center">Progreso</th>
            </tr>
          </thead>
          <tbody class="divide-y">
            <tr v-for="(product, key) in order.products" :key="key" class="hover:bg-gray-50">
              <td class="p-3">{{product.product.code}}</td>
              <td class="p-3">{{product.product.description}}</td>
              <td class="p-3 text-center">{{product.quantity}}</td>
              <td class="p-3">
                <div class="flex items-center justify-center gap-2">
                  <div class="w-24 bg-gray-200 rounded-full h-2.5">
                    <div 
                      class="h-2.5 rounded-full transition-all"
                      :class="product.quantity_packing >= product.quantity ? 'bg-green-500' : 'bg-orange-500'"
                      :style="`width: ${(product.quantity_packing/product.quantity)*100}%`"
                    ></div>
                  </div>
                  <span :class="product.quantity_packing >= product.quantity ? 'text-green-600' : ''">
                    {{product.quantity_packing}}/{{product.quantity}}
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mt-6 flex justify-end">
        <button 
          v-if="order.order_state == 'picking' && (role == 'admin' || role == 'storer') && prepared_packing()"
          @click="changeOrderState()"
          class="btn-blue"
        >
          <i class="fa fa-check mr-2"></i>
          Procesar orden a packing
        </button>
      </div>
    </div>


    <order-nulled 
      v-if="(order.order_state == 'estimate' || order.order_state == 'cancel' || (order.order_state == 'request' && !order.isCredit)) && role == 'supersales' || role == 'admin'"
      :order="order"
    ></order-nulled>
    <!-- <div v-if="order.pays.length == 0 && order.order_state == 'request'" class="mt-5 p-5 text-right bg-white shadow">
      <button v-if="order.order_state != 'cancel'" @click="cancelOrder()" class="text-md p-2 text-white bg-red-500 rounded">Anular Orden</button>
    </div> -->

    <!-- <pagination class="mt-6" :links="vendors.links" /> -->
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput.vue'
import PaymentBox from '../../Shared/PaymentBox.vue'
import OrderNulled from '../../Shared/OrderNulled.vue'
import OrderState from '../../Shared/OrderState.vue'
import OrderDiscount from '../../Shared/OrderDiscount.vue'
import OrderExpiryDate from '../../Shared/OrderExpiryDate.vue'

export default {
  components: {
    Head,
    Link,
    TextInput,
    PaymentBox,
    OrderNulled,
    OrderState,
    OrderDiscount,
    OrderExpiryDate
  },
  layout: Layout,
  props: {
    order: Object,
    dispatches: Object,
    barcode: Object,
    payment_methods: Object
  },
  data() {
    return {
      prepared_packing: () => {
        let result = true;
        this.order.products.forEach(element => {
            if(element.quantity != element.quantity_packing)
            {
              result = false;
            }
        });
        return result;
      },
      role: this.$parent.auth.user.role,
      title: 'Pedidos',
      form: this.$inertia.form({
        amount: 0,
        method: '',
        order_id: this.order.id,
        reference: '',
      }),
      products: this.$inertia.form({
        products: this.order.products,
        order_id: this.order.id,
      }),
      packing: this.$inertia.form({
        code: '',
        quantity: 1,
        order_id: this.order.id
      }),
    }
  },
  mounted() {
    this.title = this.role == 'storer' ? 'Pedido' : 'Venta';
  },
  methods: {
    formatDate(fecha) {
      const opciones = { year: 'numeric', month: 'long', day: 'numeric' };

      return new Date(fecha).toLocaleDateString('es-ES', opciones);
    },
    back() {
      window.history.back()
    },
    cancelOrder() {
      if (confirm('Estas seguro que quieres anular esta orden?')) {
        window.location.href = `/orders/${this.order.id}/cancel`
      }
    },
    addPacking() {
      this.packing.post('/orders/packing');
      this.packing.code = '';
      this.packing.quantity = 1;
    },
    addDispatch() {
      this.products.post('/orders/dispatch')
    },
    addPay() {
      if(this.order.only_cash)
      {
        if(this.order.total < parseInt(this.form.amount))
        {
          return alert("No se pueden realizar pagos parciales, solo completo y en efectivo")
        }
      }

      if (this.form.method === 'transferencia' || this.form.method === 'transferencia-usd' || this.form.method === 'zelle') {
        if (!this.form.reference) {
          alert('Debe ingresar una referencia')
          return false
        }
      }
      if (this.order.total < parseInt(this.form.amount) + parseInt(this.order.balance)) {
        return alert('No se puede agregar este pago si el monto es mayor al balance')
      }
      this.form.order_id = this.order.id
      this.form.post('/orders/pay')
      console.log(this.form)

      this.cleanPay()
    },
    changeOrderState(modality = 'no-credit', pay = null) {
      this.$inertia.get(`/orders/${this.order.id}/changeState?modality=${modality}&pay=${pay}`)
    },
    changeStatePay(orderPay, state) {
      this.$inertia.get(`/orders/pay/${orderPay}/changeState/${state}`)
    },
    cleanPay() {
      this.form = this.$inertia.form({
        amount: 0,
        method: '',
        order_id: this.order.id,
        reference: '',
      })
    },
    deleteDiscount(id)
    {
      this.$inertia.delete(`/orders/discounts/${id}`)
    }
  },
}
</script>
